<template>
  <div class="selected" ref="selectBox" @click.stop="showOptions">
    <span v-if="selectedItem">{{selectedItem.val}}</span>
    <span v-if="!selectedItem">Nothing here</span>
    <i class="sel-arr" :class="{on: showOption}"></i>
    <k-option
      @closePopover="closeOptions"
      v-if="showOption"
      ref="optionBox"
      :selected="selectedItem"
      :size="size"
      :pos="pos"
      :val="options"
    ></k-option>
  </div>
</template>

<script>
import kOption from "./option.vue";

/**
 *
 * getCoords
 * 获取dom元素距离文档root的left 和top值
 */
function getCoords(elem) {
  var box = elem.getBoundingClientRect();

  var body = document.body;
  var docEl = document.documentElement;

  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;

  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
}

export default {
  name: "k-select",
  components: {
    kOption
  },
  props: ["selected", "options"],
  data() {
    return {
      showOption: false,
      pos: {},
      size: {},
      available: true
    };
  },
  methods: {
    getPos() {
      this.pos = getCoords(this.$refs["selectBox"]);
    },
    getSize() {
      this.size = {
        width: this.$refs["selectBox"].offsetWidth,
        height: this.$refs["selectBox"].offsetHeight
      };
    },
    showOptions() {
      if (!this.available) return;
      this.getPos();
      this.getSize();
      this.showOption = true;
    },
    closeOptions(item) {
      this.showOption = false;
      if (item) {
        this.selectedItem = item;
        this.$emit("selectedOption", item);
      }
      this.available = false;
      setTimeout(() => {
        this.available = true;
      }, 500);
    },
    handleResize() {
      if(!this.showOption){
        return;
      }
      // 这里可以添加节流函数
      this.getPos();
      this.$refs["optionBox"].changeDom();
    }
  },
  created() {
    this.selectedItem = this.selected;
  },
  mounted() {
    const _this = this;
    window.addEventListener("resize", _this.handleResize);
  },
  beforeDestroy() {
    const _this = this;
    window.removeEventListener("resize", _this.handleResize);
  }
};
</script>

<style lang="scss" scoped>
.selected {
  padding: 0 40px 0 20px;
  box-sizing: border-box;
  color: #50bbe5;
  cursor: pointer;
}
.sel-arr {
  position: absolute;
  top: 10px;
  right: 8px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 7px 7px 0;
  border-style: solid;
  border-color: #50bbe5 transparent transparent;
  transition: transform 0.2s;
  &.on {
    transform: rotate(180deg);
  }
}
</style>
